import { create } from 'zustand';

const useRootOrganizationStore = create((set) => ({
    rootOrganization: {},
    storeRootOrganization: (rootOrganization) => set(() => ({ rootOrganization: rootOrganization ?? {} }))
}));

export default useRootOrganizationStore;